import { useEffect, useState } from "react";

/**
 * Hook pour capturer l'événement beforeinstallprompt et gérer l'installation PWA.
 * Retourne: { canInstall, isInstalled, install, dismiss, dismissed }
 */
export function usePwaInstall() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(
    () => typeof window !== "undefined" && localStorage.getItem("oscop_pwa_dismissed") === "1"
  );
  const [isInstalled, setIsInstalled] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
  });

  useEffect(() => {
    const onBeforeInstall = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    const onAppInstalled = () => {
      setIsInstalled(true);
      setDeferredPrompt(null);
    };
    window.addEventListener("beforeinstallprompt", onBeforeInstall);
    window.addEventListener("appinstalled", onAppInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onBeforeInstall);
      window.removeEventListener("appinstalled", onAppInstalled);
    };
  }, []);

  const install = async () => {
    if (!deferredPrompt) return false;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    return outcome === "accepted";
  };

  const dismiss = () => {
    setDismissed(true);
    try { localStorage.setItem("oscop_pwa_dismissed", "1"); } catch {}
  };

  const canInstall = !!deferredPrompt && !isInstalled && !dismissed;

  return { canInstall, isInstalled, install, dismiss };
}
